import { render } from "./MediaSettings.vue?vue&type=template&id=49faacf4&scoped=true"
import script from "./MediaSettings.vue?vue&type=script&lang=js"
export * from "./MediaSettings.vue?vue&type=script&lang=js"

import "./MediaSettings.vue?vue&type=style&index=0&id=49faacf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49faacf4"]])

export default __exports__